import React, { useMemo } from 'react';
import css from './styles.module.scss';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import Box from '@material-ui/core/Box';
import { DealSummaryListDto } from '~/models/deals/DealsListItem.dto';
import { CardHeader } from '@material-ui/core';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import { useDateFormat } from '~/common/date-format';
import moment from 'moment/moment';

interface Props {
    item: DealSummaryListDto & { legalEntityName?: string };
    onChange(isChecked: boolean): void;
}

export const DealCard: React.FC<Props> = ({ item, onChange }) => {
    const { formatDate } = useDateFormat();
    const [checked, setChecked] = React.useState(item.linkedFlag === 1);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = !!event.target.checked;
        setChecked(value);
        onChange(value);
    };

    const image: string | undefined = useMemo(() => {
        return process.env.REACT_APP_ASSET + item.contactImage || undefined;
    }, [item]);

    return (
        <Card className={css.module} elevation={0}>
            <CardHeader
                className={css.header}
                avatar={
                    <AvatarGroup>
                        <Avatar variant="square" className={css.avatar} alt={item.contractTitle} src={image} />
                    </AvatarGroup>
                }
                action={
                    <Checkbox
                        checked={checked}
                        onChange={handleChange}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                        style={{ cursor: 'pointer' }}
                    />
                }
                title={item.contractTitle}
                subheader={item.legalEntityName}
            />
            <CardContent className={css.content}>
                <Box>
                    <Typography className={css.bold}>Type</Typography>
                    <Typography className={css.italic}>{item.dealType}</Typography>
                </Box>
                {item.contractStartDate && (
                    <Box>
                        <Typography className={css.bold}>Start Date</Typography>
                        <Typography className={css.italic}>{item.contractStartDate && formatDate(item.contractStartDate)}</Typography>
                    </Box>
                )}
                {!!item.statementDate && (
                    <div className={css.infoBlock}>
                        <Typography className="releasedate">Statement Date</Typography>
                        <Typography className="gray-text">{formatDate(moment(item.statementDate, 'YYYYMMDD'))}</Typography>
                    </div>
                )}
            </CardContent>
        </Card>
    );
};
